import React, {useState} from 'react'
import styled from 'styled-components'
import TimeItem from './TimeItem/TimeItem'
import {formatTime} from '../../utils/time'
import {_L, useLocaleState} from '../../context/LocaleContext'

const Container = styled.div`
  box-sizing: border-box;
`

const ItemContainer = styled.div`
  padding-bottom: 8px;
  box-sizing: border-box;
`

// TODO: Repeated.. consolidate
const Label = styled.div`
  font-size: 16px;
  color: #a4a9b7;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
`

const generateTimeRanges = ({
  MorningStartTime,
  AfternoonStartTime,
  AfternoonEndTime
}) => {
  return {
    morningStart: formatTime(MorningStartTime, 'LT'),
    afternoonStart: formatTime(AfternoonStartTime, 'LT'),
    afternoonEnd: formatTime(AfternoonEndTime, 'LT')
  }
}

const TimeSegment = ({value, onSelect, timeRanges}) => {
  const localeState = useLocaleState()
  const [selectedIndex, setSelectedIndex] = useState(value)

  const doSelect = selectedIndex => {
    setSelectedIndex(selectedIndex)
    onSelect({selectedIndex})
  }

  const {morningStart, afternoonStart, afternoonEnd} = generateTimeRanges(
    timeRanges
  )

  return (
    <Container>
      <Label>{_L({key: 'Time', localeState})}</Label>
      <ItemContainer>
        <TimeItem
          label={_L({key: 'Full Day', localeState})}
          onSelect={doSelect}
          index={0}
          selected={selectedIndex === 0}
          startTime={morningStart}
          endTime={afternoonEnd}
        />
      </ItemContainer>
      <ItemContainer>
        <TimeItem
          label={_L({key: 'Morning', localeState})}
          onSelect={doSelect}
          index={1}
          selected={selectedIndex === 1}
          startTime={morningStart}
          endTime={afternoonStart}
        />
      </ItemContainer>
      <ItemContainer>
        <TimeItem
          label={_L({key: 'Afternoon', localeState})}
          onSelect={doSelect}
          index={2}
          selected={selectedIndex === 2}
          startTime={afternoonStart}
          endTime={afternoonEnd}
        />
      </ItemContainer>
    </Container>
  )
}

TimeSegment.defaultProps = {
  onSelected: () => {},
  value: -1
}
export default TimeSegment
